"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformUBODeclarationStatusToString = transformUBODeclarationStatusToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformUBODeclarationStatusToString(uboDeclarationStatus) {
    switch (uboDeclarationStatus) {
        case legacy_enums_1.IUBODeclarationStatus.CREATED:
            return "Created";
        case legacy_enums_1.IUBODeclarationStatus.INCOMPLETE:
            return "Incomplete";
        case legacy_enums_1.IUBODeclarationStatus.REFUSED:
            return "Refused";
        case legacy_enums_1.IUBODeclarationStatus.VALIDATED:
            return "Validated";
        case legacy_enums_1.IUBODeclarationStatus.VALIDATION_ASKED:
            return "Validation asked";
        default:
            return "Unknown";
    }
}
//# sourceMappingURL=transformUBODeclarationStatusToString.js.map